import {Component, Input, OnChanges} from '@angular/core';
import {capitalize} from './tools';
import {PlanEntity} from './entities/plan.entity';
import {PlanLayer} from './cesium/layers/default/picto.layer';

@Component({
  template: `
    @for (section of getFilter(); track section) {
      <div  class="map-layer-filter-header d-flex justify-content-between align-items-center filter-type"
            [class.active]="filters[section].collapsed">
        <span class="mb-0 cursor-pointer fs-6 fw-bold map-layer-filter-title" (click)="collapse(filters[section])">
          {{section}} <i class="ml-3 bi bi-caret-{{filters[section].collapsed ? 'up' : 'down'}}"></i>
        </span>

        <mat-slide-toggle #slider [matTooltip]="filters[section].active ? 'Désactiver tous les filtres' : 'Activer tous les filtres'"
                          (change)="toggleSection(section, $event)"
                          [ngModel]="allFiltersActive(section)"
                          class="mb-2">
        </mat-slide-toggle>
      </div>
      @if (filters[section].collapsed) {
        <ul  class="map-layer-filter-list list-unstyled filter-type_list d-flex flex-column mb-0 mt-3 mb-3">
          @for (layer of filters[section] | orderBy: 'title'; track layer.id) {
            <li class="d-flex align-items-center gap-2 pb-2" [style.order]="layer.sort" >
              <mat-checkbox  (change)="applyFilters()"
                             [name]="layer.section"
                             [id]="layer.section + '-' + layer.title + '-filter'"
                             [(ngModel)]="layer.active">
                          <span class="line-break p-0">
                              {{layer.title}}
                          </span>
              </mat-checkbox>
            </li>
          }
        </ul>
      }
    }
  `,
  selector: 'map-picto-plan-filter',
  styles: [`
    .line-break {
      white-space: normal;
      line-height: 16px;
    }
  `],
  standalone: false
})

export class MapPlanLayerFilterComponent implements OnChanges {

  @Input() layer: PlanLayer;

  filters = {};

  constructor() {}

  ngOnChanges(): void {
    this.handleFilter();
  }

  collapse(section): void {
    section.collapsed = !section.collapsed;
  }

  getFilter(): string[] {
    return Object.keys(this.filters);
  }

  allFiltersActive(section): boolean {
    return this.filters[section].every((filter) => filter.active);
  }

  toggleSection(section, $event): void {
    this.filters[section].forEach((filter) => {
      filter.active = $event.checked;
    });
    this.applyFilters();
  }

  handleFilter(): void {
    this.layer.entities.forEach((entity) => {
      Object.keys(entity.filter).forEach((section) => {
        this.setFilter(section, entity.filter[section]);
      });
    });

    this.applyFilters();
  }

  setFilter(section: string, filter): void {
    const _title = capitalize(filter.name?.replace(/_/g, ' '));

    if (this.filters[section]?.find((_filter) => _filter.id === filter.id)) {
      return;
    }

    if (!this.filters[section]) {
      this.filters[section] = [];
    }

    this.filters[section].push({
      section,
      title: _title,
      collapsed: true,
      name: filter.name,
      active: filter.active,
      sort: filter.sort,
      id: filter.id
    });
  }

  applyFilters(): void {
    const activeFilter: any = Object.entries(this.filters).map(([key, value]) => {
      // @ts-ignore
      return value.filter((filter) => {
        return filter.active;
      });
    }).flat().map((filter) => {
      return filter.id;
    });

    this.layer.entities.forEach((entity: PlanEntity, key) => {
      const shouldBeActive = entity.filterBy.every((filterId) => activeFilter.includes(filterId));
      this.layer.toggleEntity(key, shouldBeActive);
    });
  }
}
